<div class="paginator-wrapper">
  <div class="paginator-left-container">
    <div class="total-records">
      {{ 'Total' | translate }}: {{ totalRecords }}
    </div>
    <div class="page-size-selector">
      <select [ngModel]="pageSize" (ngModelChange)="onRowsPerPageChange($event)" class="rows-per-page">
        <option *ngFor="let option of rowsPerPageOptions" [ngValue]="option">
          {{ option }}
        </option>
      </select>
    </div>
    <div class="current-report">
      {{ first + 1 }} - {{ (first + pageSize) > totalRecords ? totalRecords : (first + pageSize) }} {{ 'of' | translate
      }} {{ totalRecords }}
    </div>
  </div>
  <p-paginator [first]="first" [rows]="pageSize" [totalRecords]="totalRecords" [showFirstLastIcon]="true"
    (onPageChange)="onPageChange($event)" styleClass="custom-paginator">
  </p-paginator>
</div>
